module.exports = __webpack_public_path__ + "static/CreatedShop-9b5c4e79531c1550611d2d201f0385b1.png";